module.exports = __webpack_public_path__ + "static/media/approve-transfer.svg.a6c1a739.png";